import{useState}from'react'
import{jsPDF}from'jspdf'
import{supabase}from'../supabase'

export default function ContractGenerator({event,deal,contacts}){
const[generating,setGenerating]=useState(false)
const[contract,setContract]=useState(null)
const[saved,setSaved]=useState(false)

const artist=contacts.find(c=>c.role==='artist')
const agent=contacts.find(c=>c.role==='agent')
function downloadPDF(){
const doc=new jsPDF()
const lines=doc.splitTextToSize(contract,180)
doc.setFont('helvetica')
doc.setFontSize(11)
doc.text(lines,15,20)
doc.save(event.name+'-contract.pdf')}
function generateContract(){
setGenerating(true)
const date=new Date(event.event_date).toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'})
const text=`PERFORMANCE AGREEMENT

This Performance Agreement ("Agreement") is entered into as of ${new Date().toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'})}.

PARTIES
Presenter: Dreamland Nantucket
Artist: ${event.artist_name||'TBD'}
${agent?'Agent/Representative: '+agent.name+' ('+agent.company+')':''}

EVENT DETAILS
Venue: ${event.name}
Date: ${date}
Performance Time: TBD

COMPENSATION
Artist Guarantee: $${deal?parseFloat(deal.guarantee_amount).toFixed(2):'0.00'}
Deal Type: ${deal?deal.deal_type.replace(/_/g,' '):'flat guarantee'}
${deal&&deal.door_percentage>0?'Door Percentage: '+deal.door_percentage+'%':''}
${deal&&deal.travel_covered?'Travel: Covered up to $'+parseFloat(deal.travel_cap).toFixed(2):'Travel: Not covered'}
${deal&&deal.hospitality_buyout>0?'Hospitality Buyout: $'+parseFloat(deal.hospitality_buyout).toFixed(2):''}
${deal&&deal.comp_tickets>0?'Complimentary Tickets: '+deal.comp_tickets:''}
${deal&&deal.deposit_required?'Deposit Required: $'+parseFloat(deal.deposit_amount).toFixed(2):''}

TERMS
1. The Artist agrees to perform for the full contracted performance time.
2. Payment will be made within 24 hours of the performance via the agreed method.
3. This agreement is binding upon signature by both parties.
4. Cancellation by Artist within 30 days of event date forfeits any deposit paid.
5. Cancellation by Presenter within 30 days of event date requires payment of 50% of guarantee.

SIGNATURES

Presenter: _________________________ Date: _________
Printed Name: _________________________
Title: _________________________

Artist/Representative: _________________________ Date: _________
Printed Name: _________________________`
setContract(text)
setGenerating(false)}

async function saveContract(){
await supabase.from('contracts').upsert({
event_id:event.id,
contract_type:'greenroom_generated',
status:'draft',
generated_html:contract
})
setSaved(true)}

return(<div>
{!contract?(
<button className='btn-primary' onClick={generateContract} disabled={generating}>
{generating?'Generating...':'Generate Contract'}
</button>
):(
<div>
<pre style={{background:'#f9f9f9',border:'1px solid #eee',borderRadius:'8px',padding:'1.5rem',fontSize:'12px',lineHeight:'1.8',whiteSpace:'pre-wrap',fontFamily:'Georgia,serif',marginBottom:'1rem'}}>{contract}</pre>
<div style={{display:'flex',gap:'8px'}}>
<button className='btn-primary' onClick={saveContract} disabled={saved}>{saved?'Saved':'Save Contract'}</button>
<button className='btn-secondary' onClick={()=>navigator.clipboard.writeText(contract)}>Copy Text</button>
<button className='btn-secondary' onClick={downloadPDF}>Download PDF</button>
<button className='btn-secondary' onClick={()=>setContract(null)}>Regenerate</button>
<button className='btn-secondary' onClick={async()=>{if(window.confirm('Delete this contract?')){await supabase.from('contracts').delete().eq('event_id',event.id);setContract(null);setSaved(false)}}} style={{color:'#cc0000',borderColor:'#ffcccc'}}>Delete Contract</button>
</div>
</div>
)}
</div>)}